<template>
  <div>
    <div>
      <v-alert v-if="(infoTextElement != '') || apptDeleted" role="alert" :type="alertType" tabindex="0" ref="apptAlert">{{ infoText }}</v-alert>
   </div>
   <div v-if="existingAppointments && existingAppointments.length > 0">
    <v-container class="appointment-cards">
    <v-row>
      <v-col xs="12" sm="12" md="4" v-for="(item, index) in existingAppointments" :key="item.publicId">
      <v-card class="appointment-card" text tabindex="0" :ref="'app' + index" :aria-label="messages.ariaShowAppointmentText">
        <v-card-title class="subheading d-block appointment-card__title">
          <div>
            <small style="opacity:0.5;"># {{index + 1}}</small>
          </div>
          <a
            v-if="displayUrl"
            :href="'/qmaticwebbooking/#/' + (item.externalId ? item.externalId : item.publicId)"
            target="_blank"
            @focus="hideAriaLinkButton = false"
            @blur="hideAriaLinkButton = true"
            :aria-hidden="hideAriaLinkButton"
            :aria-label="messages.ariaShowAppointmentText"
          >
            {{messages.showAppointmentText.toUpperCase()}}
            <v-icon>launch</v-icon>
          </a>
        </v-card-title>
        <v-divider></v-divider>
        <v-list dense>
          <v-list-item>
            <v-list-item-content>
              <strong>{{messages.commonDateAndTimeText}}</strong>
              {{ item.date | formatDate(selectedLanguage) }} {{ item.time | formatTime(selectedLanguage) }}
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="item.peopleServices.length > 0 && item.peopleServices[0].name">
              <v-list-item-content>
                <strong v-if="item.peopleServices.length == 1">{{messages.commonServiceText}}</strong><strong v-else>{{messages.commonMultipleServicesText}}</strong>
                <span v-for="(service, index) in item.peopleServices" :key="index">
                  {{ servicesTranslations[service.publicId] && servicesTranslations[service.publicId].names && servicesTranslations[service.publicId].names[selectedLanguage.lang] ? servicesTranslations[service.publicId].names[selectedLanguage.lang] : service.name }}
                  <span v-if="configuration.multiplePeopleEnabled && service.adult">
                    ({{service.adult}}
                    <span v-if="service.adult === 1">{{messages.commonAdultText}}</span><span v-else>{{messages.commonAdultsText}}</span>
                    <span v-if="service.adult && service.child">,</span>
                    <span v-if="service.child">{{service.child}} <span v-if="service.child === 1">{{messages.commonChildText}}</span><span v-else>{{messages.commonChildrenText}}</span></span>
                    )
                  </span>
                </span>
              </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-list dense two-line>
          <v-list-item>
            <v-list-item-content>
              <strong>{{messages.commonLocationText}}</strong>
              {{ item.branchName }}
            </v-list-item-content>
          </v-list-item>
          <v-btn
            :ripple="false"
            :aria-label="messages.ariaCancelAppointment"
            icon
            class="error appointment-card__delete-btn"
            absolute
            right
            @click="triggerDialog(item)"
            @focus="hideAriaDeleteButton = false"
            @blur="hideAriaDeleteButton = true"
            :aria-hidden="hideAriaDeleteButton"
          >
            <v-icon color="white">delete</v-icon>
          </v-btn>
        </v-list>
      </v-card>
      </v-col>
    </v-row>
    </v-container>
    <!--</v-data-iterator>-->
    <v-dialog
            role="dialog"
            v-model="deleteAppointmentDialog"
            max-width="450"
            @keydown.esc="deleteAppointmentDialog = false"
          >
            <v-card>
              <v-card-title class="headline dialog-title">{{messages.cancelAppointmentHeader}}
                <v-spacer></v-spacer>
                <v-btn :ripple="false" icon @click.native="deleteAppointmentDialog = false"
                  :aria-label="messages.ariaCloseDialog"
                >
                  <v-icon color="white">close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text style="text-align:center;" tabindex="0">{{messages.cancelAppointmentConfirmationText}}</v-card-text>
              <v-card-actions>
                <v-btn
                  :ripple="false"
                  class="cancel"
                  text
                  @click.native="deleteAppointmentDialog = false"
                >{{messages.cancelAppointmentAbortButtonText}}</v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  :ripple="false"
                  class="edit"
                  text
                  v-on:click.native="cancelExistingAppointment()"
                >{{messages.cancelAppointmentConfirmButtonText}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </div>
  </div>
</template>

<script>
import RestService from '../services/restService'
import { mapState, mapMutations } from 'vuex'
import { eventHub } from '../utils/eventhub'

export default {
  name: 'AppointmentList',
  props: [
    'existingAppointments',
    'displayUrl',
    'phone',
    'email',
    'custRef',
    'firstName',
    'lastName',
    'time',
    'date',
    'services',
    'status'
  ],
  mixins: [RestService],
  data: () => ({
    deleteAppointmentDialog: false,
    existingAppointment: {},
    alertType: null,
    infoTextElement: '',
    hideAriaLinkButton: true,
    hideAriaDeleteButton: true,
    apptDeleted: null
  }),
  computed: {
    ...mapState([
      'configuration',
      'messages',
      'selectedLanguage',
      'servicesTranslations'
    ]),
    infoText () {
      if (this.infoTextElement === 'errorTooManyReschedulesCancellation') {
        return this.messages.errorTooManyReschedulesCancellation ? this.messages.errorTooManyReschedulesCancellation.split('%1').join(this.configuration.maxDays).split('%2').join(this.configuration.rescheduleFutureDays) : this.messages.errorGenericConfirm
      } else {
        return this.infoTextElement ? this.messages[this.infoTextElement] : ''
      }
    }
  },
  watch: {
    alertType () {
      if (this.alertType === 'warning' && this.infoTextElement === 'errorMessageActiveAppointments') {
        // focus the first appointment in list
        this.focusFirstAppt()
      }
    },
    status () {
      if (this.status && this.status.message) {
        if (this.status.message === 'MULTIPLE_OK') {
          this.alertType = 'info'
          this.infoTextElement = 'infoMessageActiveAppointment'
        } else if (this.status.message === 'INFO_CUSTOMERS_MULTIPLE') {
          this.alertType = 'info'
        } else if (this.status.message === 'ERROR_CUSTOMERS_MULTIPLE') {
          this.alertType = 'error'
          this.infoTextElement = 'errorMessageMultiAppMultiCustomers'
        } else if (this.status.message === 'ERROR_TOO_MANY_RESCHEDULES') {
          this.alertType = 'error'
          this.infoTextElement = 'tooManyReschedules'
        } else if (this.status.message === 'ERROR_TOO_MANY_RESCHEDULES_AND_TOO_EARLY') {
          this.alertType = 'error'
          this.infoTextElement = 'errorTooManyReschedulesCancellation'
        } else if (this.status.message === 'ERROR_SESSION_VALIDATION') {
          this.infoTextElement = ''
        } else if (this.status.message !== 'MULTIPLE_OK') {
          this.alertType = 'warning'
          if (this.existingAppointments.length > 0) {
            this.infoTextElement = 'errorMessageActiveAppointments'
          } else {
            this.infoTextElement = 'errorMessageAppointmentInThePast'
          }
        }
      } else {
        this.alertType = 'info'
        this.infoTextElement = ''
      }
    }
  },
  methods: {
    ...mapMutations([
      'setServicesTranslations'
    ]),
    triggerDialog (item) {
      this.deleteAppointmentDialog = true
      this.existingAppointment = item
    },
    focusFirstAppt () {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.app0[0].$el.focus()
        }, 500)
      })
    },
    cancelExistingAppointment () {
      var _this = this
      this.deleteAppointmentDialog = false
      this.deleteAppointment(this.existingAppointment.publicId).then(response => {
        _this.existingAppointments.splice(_this.existingAppointments.indexOf(_this.existingAppointment), 1)
        _this.alertType = 'success'
        _this.infoTextElement = 'cancelledAppointmentText'
        _this.apptDeleted = true
        if (_this.$route.name !== 'search') {
          // We need to
          _this.checkRestrictions(_this.phone, _this.email, this.existingAppointment.branch, _this.services, _this.date, _this.time, _this.custRef, _this.firstName, _this.lastName).then(response => {
            if (response.data.message === 'MULTIPLE_OK') {
              _this.alertType = 'success'
              _this.infoTextElement = 'proceedMessageAfterDelete'
            } else if (response.data.message === 'ERROR_TOO_MANY_RESCHEDULES') {
              _this.alertType = 'warning'
              _this.infoTextElement = 'tooManyReschedules'
            } else if (response.data.message === 'ERROR_TOO_MANY_RESCHEDULES_AND_TOO_EARLY') {
              _this.alertType = 'warning'
              _this.infoTextElement = 'errorTooManyReschedulesCancellation'
            } else {
              this.alertType = 'warning'
              if (this.existingAppointments.length > 0) {
                this.infoTextElement = 'errorMessageActiveAppointments'
              } else {
                this.infoTextElement = 'errorMessageAppointmentInThePast'
              }
            }
            _this.$emit(
              'appointment-deleted',
              _this.alertType === 'warning'
            )
          })
        }
      })
    }
  },
  mounted () {
    var tempServicesTranslations = {}
    var _this = this
    this.getServices().then(response => {
      if (this.funcDebug) console.log('AppointmentList:mounted:getServices.then')
      var allServices = response.data
      allServices.forEach(service => {
        tempServicesTranslations[service.publicId] = {}
        if (service.custom) {
          service.custom = JSON.parse(service.custom)
          tempServicesTranslations[service.publicId].names = service.custom.names
        } else {
          tempServicesTranslations[service.publicId].names = {}
        }
      })
      _this.setServicesTranslations(tempServicesTranslations)
    })
    if (this.status && this.status.message) {
      if (this.status.message === 'MULTIPLE_OK') {
        this.alertType = 'info'
        this.infoTextElement = 'infoMessageActiveAppointment'
      } else if (this.status.message === 'INFO_CUSTOMERS_MULTIPLE') {
        this.alertType = 'info'
      } else if (this.status.message === 'ERROR_CUSTOMERS_MULTIPLE') {
        this.alertType = 'error'
        this.infoTextElement = 'errorMessageMultiAppMultiCustomers'
        this.$refs.app0.$el.focus()
      } else if (this.status.message === 'ERROR_TOO_MANY_RESCHEDULES') {
        this.alertType = 'error'
        this.infoTextElement = 'tooManyReschedules'
      } else if (this.status.message === 'ERROR_TOO_MANY_RESCHEDULES_AND_TOO_EARLY') {
        this.alertType = 'error'
        this.infoTextElement = 'errorTooManyReschedulesCancellation'
      } else if (this.status.message === 'ERROR_SESSION_VALIDATION') {
        this.infoTextElement = ''
      } else if (this.status.message !== 'MULTIPLE_OK') {
        this.alertType = 'warning'
        if (this.existingAppointments.length > 0) {
          this.infoTextElement = 'errorMessageActiveAppointments'
        } else {
          this.infoTextElement = 'errorMessageAppointmentInThePast'
        }
      }
    } else {
      this.alertType = 'info'
      this.infoTextElement = ''
    }
    eventHub.$on('appointments-found', (msg) => { this.infoTextElement = msg })
  }
}
</script>

<style lang="scss">
.appointment-cards {
  padding: 24px;
}

.appointment-cards .appointment-card {
  margin: 0 10px 0 0;
  border: 1px solid var(--input-border-color) !important;
}
.appointment-card .v-list--dense {
  padding-top: 10px;
  padding-bottom: 0px;
}

.appointment-card .v-list--dense.v-list--two-line {
    padding-top: 0px;
    padding-bottom: 10px;
}

.appointment-card {
  border-radius: 2px !important;
  &__title {
    @at-root [dir="rtl"] & {
      text-align: right;
    }
  }
  &__delete-btn {
    top: 10px;
    right: 16px;

    @at-root [dir="rtl"] & {
      right: auto;
      left: 16px;
    }
  }
}

.subheading {
  font-size: 16px !important;
  .v-icon {
    margin-bottom: 8px;
  }
}

.v-list--dense .v-list__tile:not(.v-list__tile--avatar) {
    height:auto;
}

@media only screen and (max-width: 599px) {
  .appointment-cards {
    padding: 16px;
  }

  .appointment-cards .appointment-card {
    margin: 10px 0;
    width: 100%;
  }
}
</style>
